module.exports = __webpack_public_path__ + "img/background_05.3bd7b630.png";